//Reset data
export const RESET = "SECTEUR_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "SECTEUR_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "SECTEUR_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "SECTEUR_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "SECTEUR_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "SECTEUR_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "SECTEUR_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "SECTEUR_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "SECTEUR_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "SECTEUR_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "SECTEUR_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "SECTEUR_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "SECTEUR_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "SECTEUR_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "SECTEUR_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "SECTEUR_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "SECTEUR_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "SECTEUR_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "SECTEUR_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "SECTEUR_SHOW_SET_MODAL_TYPE"